module.exports = function() {
  return new Worker(__webpack_public_path__ + "4814b7e21a56a3a28cbc.worker.js");
};